import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SuccessModel } from './success-dialog.model';
import { fuseAnimations } from '../../animations';

@Component({
    selector: 'fuse-success-dialog',
    templateUrl: './success-dialog.component.html',
    styleUrls: ['./success-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class FuseSuccessDialogComponent{
    data: SuccessModel;

    constructor(
        public dialogRef: MatDialogRef<FuseSuccessDialogComponent>,

    ) {
    }

}
